// extracted by mini-css-extract-plugin
export var searchHeader = "_84-0";
export var searchHeaderDark = "_84-1";